import React, { useState } from 'react';
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';
import Logo from '@/images/logo_simplesja.svg';
import LogoMobile from '@/images/logo_mobile.svg';

//Styles
import './styles.scss';

const HeaderElement = () => {
  const [classeMenu, setClasseMenu] = useState(true);
  const [subMenu, setSubMenu] = useState(false);
  const [subMenu2, setSubMenu2] = useState(false);

  const changeMenu = (set) => {
    setClasseMenu(() => {
      const body = document.querySelector('body');
      classeMenu
        ? (body.style.overflow = 'hidden')
        : (body.style.overflow = 'initial');
      return !classeMenu;
    });
  };

  return (
    <header>
      <Helmet>
        <meta
          name="facebook-domain-verification"
          content="7wdr6sk260y07158s5vann291zn77s"
        />
        <script
          type="text/javascript"
          id="hs-script-loader"
          async
          defer
          src="https://js-na1.hs-scripts.com/22375303.js"
        ></script>
        <script
          type="text/javascript"
          async
          src="https://d335luupugsy2.cloudfront.net/js/loader-scripts/4d903430-6d6b-45eb-98f8-fd518f8e8d53-loader.js"
        ></script>
      </Helmet>
      <div className="header container">
        <div className="header_logo">
          <Link to="/" className="header_logo_a">
            <img
              className="desktop"
              src={Logo}
              alt="Logo SimplesJá Contabilidade Digital"
            />
            <img
              className="mobile"
              src={LogoMobile}
              alt="Logo SimplesJá Contabilidade Digital"
            />
          </Link>
        </div>
        <div className="header_nav">
          <nav className={classeMenu ? 'header_nav_close' : 'header_nav_open'}>
            <button
              className="header_nav_x mobile"
              onClick={() => changeMenu(false)}
              onKeyDown={() => changeMenu(false)}
            >
              <span className="header_nav_x_lines"></span>
              <span className="header_nav_x_lines extra"></span>
            </button>
            <ul className="header_nav_ul">
              <li className="header_nav_ul_li">
                <button
                  className="header_nav_ul_li_button"
                  onClick={() => setSubMenu2(!subMenu2)}
                >
                  <span>Soluções</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="-12 -6 24 24"
                    width="18"
                    height="13"
                    type="image/svg+xml"
                    aria-expanded="false"
                    className={`${subMenu2 ? 'is-open' : ''}`}
                  >
                    <polyline points="-10,0 0,10 10,0"></polyline>
                  </svg>
                </button>
                <div
                  className={`header_nav_ul_li_sub ${
                    subMenu2 ? 'open' : 'close'
                  }`}
                >
                  <ul>
                    <li className="header_nav_ul_li_sub_li">
                      <Link to="/contabilidade-digital">
                        Contabilidade Digital
                      </Link>
                    </li>
                    <li className="header_nav_ul_li_sub_li">
                      <Link to="/bpo-financeiro">BPO Financeiro</Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="header_nav_ul_li">
                <button
                  className="header_nav_ul_li_button"
                  onClick={() => setSubMenu(!subMenu)}
                >
                  <span>Segmentos</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="-12 -6 24 24"
                    width="18"
                    height="13"
                    type="image/svg+xml"
                    aria-expanded="false"
                    className={`${subMenu ? 'is-open' : ''}`}
                  >
                    <polyline points="-10,0 0,10 10,0"></polyline>
                  </svg>
                </button>
                <div
                  className={`header_nav_ul_li_sub ${
                    subMenu ? 'open' : 'close'
                  }`}
                >
                  <ul>
                    <li className="header_nav_ul_li_sub_li">
                      <Link to="/contabilidade-digital-para-startups">
                        Para Startups
                      </Link>
                    </li>
                    <li className="header_nav_ul_li_sub_li">
                      <Link to="/contabilidade-digital-para-pj-ti">
                        Para PJ TI
                      </Link>
                    </li>
                    <li className="header_nav_ul_li_sub_li">
                      <Link to="/contabilidade-digital-para-servicos-digitais">
                        Para Serviços Digitais
                      </Link>
                    </li>
                    <li className="header_nav_ul_li_sub_li">
                      <Link to="/contabilidade-digital-para-ecommerce">
                        Para E-commerce
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="header_nav_ul_li">
                <a
                  href="https://simplesja.solides.jobs/"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="header_nav_ul_li_a mobile"
                  onClick={() => changeMenu(true)}
                >
                  Carreiras
                </a>
                <a
                  href="https://simplesja.solides.jobs/"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="header_nav_ul_li_a desktop"
                >
                  Carreiras
                </a>
              </li>
              <li className="header_nav_ul_li">
                <a
                  href="https://conteudo.simplesja.com.br/gerador-de-invoice-simplesja"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="header_nav_ul_li_a mobile"
                  onClick={() => changeMenu(true)}
                >
                  Ferramentas
                </a>
                <a
                  href="https://conteudo.simplesja.com.br/gerador-de-invoice-simplesja"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="header_nav_ul_li_a desktop"
                >
                  Ferramentas
                </a>
              </li>
              <li className="header_nav_ul_li">
                <a
                  href="https://blog.simplesja.com.br"
                  target="_blank noreferrer"
                  className="header_nav_ul_li_a mobile"
                  onClick={() => changeMenu(true)}
                >
                  Blog
                </a>
                <a
                  href="https://blog.simplesja.com.br"
                  target="_blank noreferrer"
                  className="header_nav_ul_li_a desktop"
                >
                  Blog
                </a>
              </li>
            </ul>
            <div className="header_nav_button mobile">
              <button className="header_nav_button">
                <Link className="header_nav_button_a" to="https://app.simplesja.com.br" target='_blank'>
                  Login
                </Link>
              </button>
            </div>
          </nav>
          <button
            className="header_menu mobile"
            onClick={() => changeMenu(true)}
            onKeyDown={() => changeMenu(false)}
          >
            <span className="header_menu_lines"></span>
            <span className="header_menu_lines"></span>
            <span className="header_menu_lines"></span>
          </button>
        </div>
        <div className="header_buttons">
          <button className="header_buttons_login login desktop">
          <Link className="header_nav_button_a" to="https://app.simplesja.com.br" target='_blank'>
                  Login
                </Link>
          </button>
          <a
            href="https://conteudo.simplesja.com.br/abrir-minha-empresa-trocar-de-contador"
            className="header_buttons_login start"
          >
            Abrir empresa
          </a>
        </div>
      </div>
    </header>
  );
};

export default HeaderElement;
